//Used for Payment Element react component configuration
export const NEVER = 'never';
export const AUTO = 'auto';
export const TABS_LAYOUT = 'tabs';

// Payment method types
export const ACH_METHOD = 'us_bank_account';
export const CARD_METHOD = 'card';
export const GOOGLE_PAY_METHOD = 'google_pay';
export const APPLE_PAY_METHOD = 'apple_pay';
export const SEPA_METHOD = 'sepa_debit';
export const BACS_METHOD = 'bacs_debit';
export const PADS_METHOD = 'acss_debit';

// Setup vs Payment intent
export const PAYMENT = 'payment';
export const SETUP = 'setup';

// For recurring payments
export const OFF_SESSION = 'off_session';
export const ON_SESSION = 'on_session';

// Method of ACH verification
// 'instant_or_skip" correlated to Financial Connections used for HSP
// 'skip' for manual account entry (no microdeposits) used for BYOS
export const FC_VERIFICATION_METHOD = 'instant_or_skip';
export const MANUAL_VERIFICATION_METHOD = 'skip';

// processors
export const HS_PAYMENTS = 'HS_PAYMENTS';
export const BYO_STRIPE = 'BYO_STRIPE';

// Since Stripe doesn't load Lexend Deca by default in their iframe, we provide it here
export const ELEMENTS_FONTS = [{
  cssSrc: 'https://fonts.googleapis.com/css2?family=Lexend+Deca:wght@200;400;500;600;700;900&display=swap'
}];
const FORM_FOCUS_STYLE = theme => ({
  borderColor: theme.color['border-interactive-default'],
  boxShadow: `0 0 4px 1px ${theme.color['border-interactive-default']}, 0 0 0 1px ${theme.color['border-interactive-default']}`,
  outline: '0'
});

// https://stripe.com/docs/elements/appearance-api
export const ELEMENTS_APPEARANCE = theme => ({
  variables: {
    colorPrimary: theme.color['text-interactive-default'],
    colorText: theme.color['text-core-default'],
    colorDanger: theme.color['fill-alert-default'],
    fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
    fontSizeSm: '12px',
    fontWeightNormal: '400',
    fontWeightBold: '600',
    fontWeightMedium: '500',
    colorTextPlaceholder: theme.color['text-core-subtle'],
    borderRadius: '3px'
  },
  rules: {
    '.Label': {
      fontWeight: '700',
      color: theme.color['text-core-default'],
      fontSize: '14px'
    },
    '.Tab': {
      color: theme.color['icon-tertiary-default'],
      boxShadow: 'none',
      borderColor: theme.color['border-core-default']
    },
    '.Tab--selected': FORM_FOCUS_STYLE(theme),
    '.TabLabel--selected': {
      color: theme.color['icon-core-default']
    },
    '.Tab:hover': {
      fill: theme.color['icon-core-default']
    },
    '.TabIcon': {
      fill: theme.color['icon-tertiary-default']
    },
    '.TabIcon--selected': {
      fill: theme.color['icon-interactive-default']
    },
    '.TabIcon:hover': {
      fill: theme.color['icon-core-default']
    },
    '.Input': {
      borderColor: theme.color['border-core-default'],
      boxShadow: 'none'
    },
    '.Input:focus': FORM_FOCUS_STYLE(theme),
    '.Error': {
      fontSize: '12px',
      fontWeight: '600',
      color: theme.color['text-alert-default']
    }
  }
});